export default function CTA() {
  return (
    <section className="py-32 bg-white">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <h2 className="text-5xl font-bold text-[#002B5C] mb-6">
          Ready to Advance Your Research?
        </h2>
        <p className="text-xl text-[#6B7280] mb-10 leading-relaxed">
          Partner with InovaBioCorp for integrated scientific solutions from equipment to analysis
        </p>
        <a
          href="#contact"
          className="inline-flex items-center gap-3 px-12 py-4 bg-[#FFC107] text-[#002B5C] rounded-full text-base font-semibold hover:bg-[#FF8F00] transition-colors whitespace-nowrap cursor-pointer"
        >
          Contact Our Team
          <i className="ri-arrow-right-line text-lg"></i>
        </a>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-20">
        <div className="flex items-center justify-center gap-12 flex-wrap">
          <div className="w-32 h-32 flex items-center justify-center">
            <i className="ri-microscope-line text-8xl text-[#002B5C]"></i>
          </div>
          <div className="w-32 h-32 flex items-center justify-center">
            <i className="ri-test-tube-line text-8xl text-[#FFC107]"></i>
          </div>
          <div className="w-32 h-32 flex items-center justify-center">
            <i className="ri-flask-line text-8xl text-[#002B5C]"></i>
          </div>
          <div className="w-32 h-32 flex items-center justify-center">
            <i className="ri-capsule-line text-8xl text-[#FFC107]"></i>
          </div>
          <div className="w-32 h-32 flex items-center justify-center">
            <i className="ri-medicine-bottle-line text-8xl text-[#002B5C]"></i>
          </div>
        </div>
      </div>
    </section>
  );
}